import { render, staticRenderFns } from "./setupexample.vue?vue&type=template&id=5b63d815&"
import script from "./setupexample.vue?vue&type=script&lang=js&"
export * from "./setupexample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports